// extracted by mini-css-extract-plugin
export default {"next":"SwiperNext_next__myvAR"};